@if (state.pagination) {
  <h1 class="text-primary text-md font-semibold">
    {{
      'examdojo.showing_questions_range'
        | transloco
          : { start: state.pagination.rangeStart, end: state.pagination.rangeEnd, total: state.pagination.total }
    }}
  </h1>
}
